import styled from "styled-components";
import { StaticI18nLink } from "../../Link.js";
import { theme } from "../../../styles/theme.js";
import { device } from "../../../constants.js";
// Estilo base para todos os itens do dropdown
const baseDropdownItemStyles = `
  color: ${theme.colors["neutral-01"]};
  padding: 0px;
  font-size: 14px;
  font-weight: 500;
  line-height: 24px;
  letter-spacing: 0.7px;
  text-align: left;
  cursor: pointer;
  text-decoration: none;
  display: block;
  width: 100%;
  background: none;
  border: none;
  transition: color 100ms ease-in-out;
  text-wrap: nowrap;

  &:hover {
    color: ${theme.colors["vivid-02"]};
    text-decoration: underline;
  }

  &:focus-visible {
    outline: 2px solid ${theme.colors["vivid-02"]};
    outline-offset: 2px;
  }

  @media ${device.tablet} {
    font-size: 12px;
  }

  @media ${device.laptop} {
    font-size: 14px;
  }
`;

// Componente para botões do dropdown
export const DropdownItem = styled.button`
  ${baseDropdownItemStyles}
`;

// Componente para links externos do dropdown - sem StaticI18nLink
export const DropdownItemLinkRaw = styled.a`
  ${baseDropdownItemStyles}
`;
